export default {
  methods: {
    zClick(tag) {
      let zE = window.zE;
      if (zE) {
        zE('webWidget', 'updateSettings', {
          webWidget: {
            chat: {
              tags: [tag]
            }
          }
        });

        let path = window.location.href;
        let title = this.$route.meta.title;

        zE('webWidget', 'updatePath', {
          url: path,
          title: title
        });
      }
    }
  }
};
